import api from "./api.ts";

export const GetUserWallet = async (token, id) => {
    try {
        const response = await api.get(`/wallet/by-user/${id}/`)
        return response;
    } catch (err) {
        return err
    }
}

export const GetWalletTransactions = async (token, walletId) => {
    try {
        const response = await api.get(`/wallet-transaction/by-wallet/?wallet_id=${walletId}`)
        return response;
    } catch (err) {
        return err
    }
}

export const createOrderLink = async (
    token: string,
    data: {
        order_type: "CAMPAIGN" | "SUBSCRIPTION" | "OTHER";
        amount?: number;
        currency?: string;
        subscription?: string;
        campaign?: number;
    }
) => {
    const formData = new FormData();
    formData.append("order_type", data.order_type);
    if (data.amount) formData.append("amount", data.amount.toString());
    if (data.currency) formData.append("currency", data.currency);
    if (data.subscription) formData.append("subscription", data.subscription);
    if (data.campaign) formData.append("campaign", data.campaign.toString());

    try {
        const response = await api.post(
            `/users/order/create-link/`,
            formData,
            {
                headers: {
                    // "Authorization" token handled by interceptor
                    "Content-Type": "multipart/form-data",
                }
            }
        );
        return response;
    } catch (err) {
        throw err;
    }
};